import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48357cfe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "closefriend-hero background-white" }
const _hoisted_2 = { class: "container mt-5" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "tab-content w-100" }
const _hoisted_5 = { class: "my-4 mx-4 p-0 bg-white border-radius-10" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "row m-0 bg-card-light",
  style: {"border-radius":"10px 10px 0px 0px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 d-flex justify-content-center py-4" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "font-grey p-cursor text-center" }, [
      /*#__PURE__*/_createElementVNode("b", { style: {"color":"#6B7A99"} }, "Association Application")
    ])
  ])
], -1))
const _hoisted_7 = { class: "row my-3 justify-content-center" }
const _hoisted_8 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-10 offset-xl-1" }
const _hoisted_9 = { class: "container-fluid" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = { class: "list-unstyled multi-steps" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "Personal", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "Association", -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "External Bank Account", -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "E-Signature", -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "Upload Proof", -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { class: "row my-3 justify-content-center" }
const _hoisted_24 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2" }
const _hoisted_25 = { class: "login-card" }
const _hoisted_26 = { class: "login-body association" }
const _hoisted_27 = { class: "row mt-3" }
const _hoisted_28 = { class: "col-md-12 col-12" }
const _hoisted_29 = { class: "form-group" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, [
  /*#__PURE__*/_createTextVNode(" Ref No"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("small", null, "If you have been given a Ref number by Caprock please enter it here.")
], -1))
const _hoisted_31 = { class: "col-md-12 col-12" }
const _hoisted_32 = { class: "form-group" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, [
  /*#__PURE__*/_createTextVNode(" Advisor Ref No"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("small", null, "If you have been given a Advisor Ref number by Caprock please enter it here.")
], -1))
const _hoisted_34 = { class: "col-md-12 col-12" }
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Type of assciation", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Incorporated Association", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Unincorporated Association", -1))
const _hoisted_40 = { class: "col-md-12 col-12" }
const _hoisted_41 = { class: "form-group" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "The full name of the association", -1))
const _hoisted_43 = {
  key: 0,
  class: "col-md-12 col-12"
}
const _hoisted_44 = { class: "form-group" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Any unique identifying number issued to the association upon its incorporation", -1))
const _hoisted_46 = { class: "col-md-12 col-12" }
const _hoisted_47 = { class: "form-group" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Investment Currency", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_50 = ["value"]
const _hoisted_51 = { class: "col-md-12 col-12" }
const _hoisted_52 = { class: "form-group" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Expected investment amount", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "$500k-$50 million" }, "$500k-$50 million", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "$50-$100 million" }, "$50-$100 million", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "$100 million +" }, "$100 million +", -1))
const _hoisted_58 = { class: "col-md-12 col-12" }
const _hoisted_59 = { class: "form-group" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Profile Picture", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_62 = ["src"]
const _hoisted_63 = {
  key: 3,
  class: "progress"
}
const _hoisted_64 = ["aria-valuenow"]
const _hoisted_65 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-1" }
const _hoisted_66 = { class: "row justify-content-end mx-md-0 mx-1 mb-5" }
const _hoisted_67 = { class: "col-3 px-1" }
const _hoisted_68 = { class: "col-3 px-1" }
const _hoisted_69 = { class: "col-3 px-1" }
const _hoisted_70 = { class: "row my-3 justify-content-center" }
const _hoisted_71 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3" }
const _hoisted_72 = { class: "login-card" }
const _hoisted_73 = { class: "login-body business" }
const _hoisted_74 = { class: "row mt-3" }
const _hoisted_75 = { class: "col-md-12 col-12" }
const _hoisted_76 = { class: "form-group" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Applicant's Country", -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_79 = ["value"]
const _hoisted_80 = { class: "col-md-12 col-12" }
const _hoisted_81 = { class: "form-group" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "The full address of the association’s principal place of administration or registered office.", -1))
const _hoisted_83 = { class: "form-group place_suggest_p_r d-none" }
const _hoisted_84 = {
  class: "card place_suggest_p_r",
  style: {"max-width":"100%","overflow-y":"scroll","max-height":"250px"}
}
const _hoisted_85 = ["onClick"]
const _hoisted_86 = ["id"]
const _hoisted_87 = { style: {"font-weight":"600","cursor":"pointer"} }
const _hoisted_88 = {
  class: "p-0 m-0",
  style: {"color":"grey","cursor":"pointer"}
}
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "m-0" }, null, -1))
const _hoisted_90 = { class: "col-md-12 col-12" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-group" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Chairman of association")
], -1))
const _hoisted_92 = { class: "col-md-12 col-12" }
const _hoisted_93 = { class: "form-group" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Name", -1))
const _hoisted_95 = { class: "col-md-12 col-12" }
const _hoisted_96 = { class: "form-group" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Email", -1))
const _hoisted_98 = { class: "col-md-12 col-12" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-group" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Secretary of association")
], -1))
const _hoisted_100 = { class: "col-md-12 col-12" }
const _hoisted_101 = { class: "form-group" }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Name", -1))
const _hoisted_103 = { class: "col-md-12 col-12" }
const _hoisted_104 = { class: "form-group" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Email", -1))
const _hoisted_106 = { class: "col-md-12 col-12" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-group" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Treasurer of association")
], -1))
const _hoisted_108 = { class: "col-md-12 col-12" }
const _hoisted_109 = { class: "form-group" }
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Name", -1))
const _hoisted_111 = { class: "col-md-12 col-12" }
const _hoisted_112 = { class: "form-group" }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Email", -1))
const _hoisted_114 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-1" }
const _hoisted_115 = { class: "row justify-content-end mx-md-0 mx-1 mb-5" }
const _hoisted_116 = { class: "col-3 px-1" }
const _hoisted_117 = { class: "col-3 px-1" }
const _hoisted_118 = { class: "col-3 px-1" }
const _hoisted_119 = { class: "row my-3 justify-content-center" }
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "login-card" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "login-body association" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "row mt-3" })
    ])
  ])
], -1))
const _hoisted_121 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-1" }
const _hoisted_122 = { class: "row justify-content-end mx-md-0 mx-1 mb-5" }
const _hoisted_123 = { class: "col-3 px-1" }
const _hoisted_124 = { class: "col-3 px-1" }
const _hoisted_125 = { class: "row my-3 justify-content-center" }
const _hoisted_126 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3" }
const _hoisted_127 = { class: "login-card" }
const _hoisted_128 = { class: "login-body association" }
const _hoisted_129 = { class: "row mt-3" }
const _hoisted_130 = { class: "col-md-12 col-12" }
const _hoisted_131 = { class: "form-group" }
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Name", -1))
const _hoisted_133 = { class: "col-md-12 col-12" }
const _hoisted_134 = { class: "form-group" }
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Email", -1))
const _hoisted_136 = { class: "col-md-12 col-12" }
const _hoisted_137 = { class: "form-group" }
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Phone Number", -1))
const _hoisted_139 = { class: "col-md-12 col-12" }
const _hoisted_140 = { class: "form-group" }
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Date of Birth", -1))
const _hoisted_142 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-1" }
const _hoisted_143 = { class: "row justify-content-end mx-md-0 mx-1 mb-5" }
const _hoisted_144 = { class: "col-3 px-1" }
const _hoisted_145 = { class: "col-3 px-1" }
const _hoisted_146 = { class: "col-3 px-1" }
const _hoisted_147 = { class: "row my-3 justify-content-center" }
const _hoisted_148 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3" }
const _hoisted_149 = { class: "login-card" }
const _hoisted_150 = { class: "login-body association" }
const _hoisted_151 = { class: "row mt-3" }
const _hoisted_152 = { class: "form-group" }
const _hoisted_153 = { class: "font-grey" }
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_155 = ["onClick"]
const _hoisted_156 = ["innerHTML"]
const _hoisted_157 = {
  key: 3,
  class: "progress"
}
const _hoisted_158 = ["aria-valuenow"]
const _hoisted_159 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-1" }
const _hoisted_160 = { class: "row justify-content-end mx-md-0 mx-1 mb-5" }
const _hoisted_161 = { class: "col-3 px-1" }
const _hoisted_162 = { class: "col-3 px-1" }
const _hoisted_163 = { class: "col-3 px-1" }
const _hoisted_164 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "modal fade sending_email",
  id: "sending_email",
  role: "dialog"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "modal-dialog modal-sm modal-dialog-centered",
    role: "document"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "modal-content bg-light" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "modal-body mb-2" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "row mx-1 mt-4" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 text-center" }, [
            /*#__PURE__*/_createElementVNode("p", null, "Sending document to your mail ! Please Wait.....")
          ])
        ])
      ])
    ])
  ])
], -1))
const _hoisted_165 = {
  class: "modal fade cancel_request",
  id: "cancel_request",
  role: "dialog"
}
const _hoisted_166 = {
  class: "modal-dialog modal-md modal-dialog-centered",
  role: "document"
}
const _hoisted_167 = { class: "modal-content" }
const _hoisted_168 = { class: "modal-body mb-2" }
const _hoisted_169 = { class: "row mx-1 mt-1" }
const _hoisted_170 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"larger"} }, "Cancelling will delete all details entered.")
], -1))
const _hoisted_171 = { class: "col-md-12 text-left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_basic = _resolveComponent("basic")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_Banks = _resolveComponent("Banks")!
  const _component_toasti = _resolveComponent("toasti")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_basic, { load_on: _ctx.load_on }, null, 8, ["load_on"]),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _hoisted_11,
                    _createElementVNode("ul", _hoisted_12, [
                      _createElementVNode("li", {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.set_step(1);}),
                        class: _normalizeClass(["p-cursor", {'is-active':_ctx.active_tab=='association'}])
                      }, _hoisted_14, 2),
                      _createElementVNode("li", {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.set_step(2);}),
                        class: _normalizeClass(["p-cursor", {'is-active':_ctx.active_tab=='business'}])
                      }, _hoisted_16, 2),
                      _createElementVNode("li", {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.set_step(3);}),
                        class: _normalizeClass(["p-cursor", {'is-active':_ctx.active_tab=='account'}])
                      }, _hoisted_18, 2),
                      _createElementVNode("li", {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.set_step(4);}),
                        class: _normalizeClass(["p-cursor", {'is-active':_ctx.active_tab=='e_signature'}])
                      }, _hoisted_20, 2),
                      _createElementVNode("li", {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.set_step(5);}),
                        class: _normalizeClass(["p-cursor", {'is-active':_ctx.active_tab=='upload'}])
                      }, _hoisted_22, 2)
                    ])
                  ])
                ])
              ]),
              (this.current_step==1)
                ? (_openBlock(), _createBlock(_component_Form, {
                    key: 0,
                    method: "POST",
                    action: "/",
                    class: "my-1 card p-2",
                    onSubmit: _ctx.submitForm_1
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("div", _hoisted_27, [
                                _createVNode(_component_Field, {
                                  modelValue: this.active_tab,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((this.active_tab) = $event)),
                                  name: "user_type",
                                  id: "user_type",
                                  type: "hidden"
                                }, null, 8, ["modelValue"]),
                                _createElementVNode("div", _hoisted_28, [
                                  _createElementVNode("div", _hoisted_29, [
                                    _hoisted_30,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.user_ref_no,
                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.user_ref_no) = $event)),
                                      placeholder: "ie. CM0011114",
                                      class: "form-control selected-field",
                                      name: "user_ref_no",
                                      id: "user_ref_no",
                                      type: "text",
                                      readonly: ""
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "user_ref_no"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_31, [
                                  _createElementVNode("div", _hoisted_32, [
                                    _hoisted_33,
                                    _createVNode(_component_Field, {
                                      readonly: _ctx.advisor_exist==1,
                                      modelValue: _ctx.form.advisor_ref_no,
                                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.advisor_ref_no) = $event)),
                                      placeholder: "ie. A042",
                                      class: "form-control selected-field",
                                      name: "advisor_ref_no",
                                      id: "advisor_ref_no",
                                      type: "text"
                                    }, null, 8, ["readonly", "modelValue"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "advisor_ref_no"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_34, [
                                  _createElementVNode("div", _hoisted_35, [
                                    _hoisted_36,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.association_type,
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.association_type) = $event)),
                                      class: "form-control",
                                      name: "association_type",
                                      as: "select",
                                      rules: _ctx.selectField
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_37,
                                        _hoisted_38,
                                        _hoisted_39
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "association_type"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_40, [
                                  _createElementVNode("div", _hoisted_41, [
                                    _hoisted_42,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.association_name,
                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.association_name) = $event)),
                                      class: "form-control selected-field",
                                      name: "association_name",
                                      placeholder: "association name here",
                                      type: "text",
                                      rules: [_ctx.requiredField]
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "association_name"
                                    })
                                  ])
                                ]),
                                (_ctx.form.association_type==1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                      _createElementVNode("div", _hoisted_44, [
                                        _hoisted_45,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.association_id_no,
                                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.association_id_no) = $event)),
                                          class: "form-control selected-field",
                                          name: "association_id_no",
                                          placeholder: "ie. IRGE345678",
                                          type: "text",
                                          rules: [_ctx.requiredField]
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "association_id_no"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_46, [
                                  _createElementVNode("div", _hoisted_47, [
                                    _hoisted_48,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.investment_currency,
                                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.investment_currency) = $event)),
                                      class: "form-control",
                                      name: "investment_currency",
                                      as: "select",
                                      rules: _ctx.selectField
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_49,
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: country.country_id,
                                            value: country.country_id
                                          }, _toDisplayString(country.currency) + " - " + _toDisplayString(country.country_name), 9, _hoisted_50))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "investment_currency"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_51, [
                                  _createElementVNode("div", _hoisted_52, [
                                    _hoisted_53,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.investment_amount,
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.investment_amount) = $event)),
                                      class: "form-control",
                                      name: "investment_amount",
                                      as: "select",
                                      rules: _ctx.selectField
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_54,
                                        _hoisted_55,
                                        _hoisted_56,
                                        _hoisted_57
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "investment_amount"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_58, [
                                  _createElementVNode("div", _hoisted_59, [
                                    _hoisted_60,
                                    _hoisted_61,
                                    (typeof _ctx.records.profile_pic_url!='undefined' && _ctx.records.profile_pic_url!='')
                                      ? (_openBlock(), _createBlock(_component_Field, {
                                          key: 0,
                                          onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.uploadFile($event))),
                                          modelValue: _ctx.form.profile_pic,
                                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.profile_pic) = $event)),
                                          class: "form-control selected-field",
                                          name: "profile_pic",
                                          type: "file"
                                        }, null, 8, ["modelValue"]))
                                      : _createCommentVNode("", true),
                                    (typeof _ctx.records.profile_pic_url=='undefined' || _ctx.records.profile_pic_url=='')
                                      ? (_openBlock(), _createBlock(_component_Field, {
                                          key: 1,
                                          onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.uploadFile($event))),
                                          modelValue: _ctx.form.profile_pic,
                                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.profile_pic) = $event)),
                                          class: "form-control selected-field",
                                          name: "profile_pic",
                                          type: "file",
                                          rules: _ctx.requiredField
                                        }, null, 8, ["modelValue", "rules"]))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "profile_pic"
                                    }),
                                    (typeof _ctx.records.profile_pic_url!='undefined' && _ctx.records.profile_pic_url!='')
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 2,
                                          class: "p-cursor",
                                          onClick: _cache[17] || (_cache[17] = ($event: any) => {_ctx.openDoc(_ctx.records.profile_pic_url);})
                                        }, [
                                          _createElementVNode("img", {
                                            class: "rounded-circle",
                                            style: {"height":"50px"},
                                            src: _ctx.records.profile_pic_url
                                          }, null, 8, _hoisted_62)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_ctx.form['profile_pic_pdiv']==1)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                          _createElementVNode("div", {
                                            class: "progress-bar bg-dark",
                                            role: "progressbar",
                                            style: _normalizeStyle({'width':_ctx.form['profile_pic_pbar']+'%'}),
                                            "aria-valuenow": _ctx.form['profile_pic_pbar'],
                                            "aria-valuemin": "0",
                                            "aria-valuemax": "100"
                                          }, _toDisplayString(_ctx.form['profile_pic_pbar_p']), 13, _hoisted_64)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_Field, {
                                      rules: _ctx.requiredField,
                                      modelValue: _ctx.form['profile_pic_path'],
                                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form['profile_pic_path']) = $event)),
                                      class: "form-control selected-field",
                                      name: "profile_pic_path",
                                      type: "hidden"
                                    }, null, 8, ["rules", "modelValue"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "profile_pic_path"
                                    })
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_65, [
                          _createElementVNode("div", _hoisted_66, [
                            _createElementVNode("div", _hoisted_67, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.openModal('cancel_request'))),
                                class: "btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Cancel ")
                            ]),
                            _createElementVNode("div", _hoisted_68, [
                              _createElementVNode("button", {
                                onClick: _cache[20] || (_cache[20] = ($event: any) => {_ctx.next_step=1;}),
                                type: "submit",
                                class: "subBtn btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save ")
                            ]),
                            _createElementVNode("div", _hoisted_69, [
                              _createElementVNode("button", {
                                onClick: _cache[21] || (_cache[21] = ($event: any) => {_ctx.next_step=2;}),
                                type: "submit",
                                class: "subBtn btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save & Next ")
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["onSubmit"]))
                : _createCommentVNode("", true),
              (this.current_step==2)
                ? (_openBlock(), _createBlock(_component_Form, {
                    key: 1,
                    method: "POST",
                    action: "/",
                    class: "my-1 card p-2",
                    onSubmit: _ctx.submitForm_2
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_70, [
                        _createElementVNode("div", _hoisted_71, [
                          _createElementVNode("div", _hoisted_72, [
                            _createElementVNode("div", _hoisted_73, [
                              _createElementVNode("div", _hoisted_74, [
                                _createElementVNode("div", _hoisted_75, [
                                  _createElementVNode("div", _hoisted_76, [
                                    _hoisted_77,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.applicant_country,
                                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.form.applicant_country) = $event)),
                                      class: "form-control",
                                      name: "applicant_country",
                                      as: "select",
                                      rules: _ctx.selectField
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_78,
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: country.country_id,
                                            value: country.country_id
                                          }, _toDisplayString(country.country_name), 9, _hoisted_79))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "applicant_country"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_80, [
                                  _createElementVNode("div", _hoisted_81, [
                                    _hoisted_82,
                                    _createVNode(_component_Field, {
                                      onKeyup: _cache[23] || (_cache[23] = ($event: any) => {_ctx.textSearch($event,'_p_r');}),
                                      onfocus: "this.setAttribute('autocomplete', 'disable-autocomplete');",
                                      autocomplete: "off",
                                      modelValue: _ctx.form.principal_address,
                                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.form.principal_address) = $event)),
                                      class: "form-control selected-field",
                                      name: "principal_address",
                                      type: "text",
                                      rules: _ctx.requiredField
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "principal_address"
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_83, [
                                    _createElementVNode("div", _hoisted_84, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.place_list, (item) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: item.id,
                                          onClick: ($event: any) => {_ctx.set_address(item.id,'principal_address','_p_r');},
                                          class: "suggestDiv_p_r"
                                        }, [
                                          _createElementVNode("div", {
                                            class: "d-none",
                                            id: 'addr_'+item.id
                                          }, _toDisplayString(item.address), 9, _hoisted_86),
                                          _createElementVNode("h6", _hoisted_87, _toDisplayString(item.title), 1),
                                          _createElementVNode("p", _hoisted_88, _toDisplayString(item.details), 1)
                                        ], 8, _hoisted_85))
                                      }), 128)),
                                      _hoisted_89
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_90, [
                                  _hoisted_91,
                                  _createElementVNode("div", _hoisted_92, [
                                    _createElementVNode("div", _hoisted_93, [
                                      _hoisted_94,
                                      _createVNode(_component_Field, {
                                        modelValue: _ctx.form.chairman_name,
                                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.form.chairman_name) = $event)),
                                        class: "form-control selected-field",
                                        name: "chairman_name",
                                        placeholder: "chairman name here",
                                        type: "text",
                                        rules: [_ctx.requiredField]
                                      }, null, 8, ["modelValue", "rules"]),
                                      _createVNode(_component_ErrorMessage, {
                                        style: {"color":"#d00000"},
                                        name: "chairman_name"
                                      })
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_95, [
                                    _createElementVNode("div", _hoisted_96, [
                                      _hoisted_97,
                                      _createVNode(_component_Field, {
                                        modelValue: _ctx.form.chairman_email,
                                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.form.chairman_email) = $event)),
                                        class: "form-control selected-field",
                                        name: "chairman_email",
                                        placeholder: "ie. chairmam@association.com",
                                        type: "text",
                                        rules: [_ctx.requiredField,_ctx.validateEmail]
                                      }, null, 8, ["modelValue", "rules"]),
                                      _createVNode(_component_ErrorMessage, {
                                        style: {"color":"#d00000"},
                                        name: "chairman_email"
                                      })
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_98, [
                                  _hoisted_99,
                                  _createElementVNode("div", _hoisted_100, [
                                    _createElementVNode("div", _hoisted_101, [
                                      _hoisted_102,
                                      _createVNode(_component_Field, {
                                        modelValue: _ctx.form.secretary_name,
                                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.form.secretary_name) = $event)),
                                        class: "form-control selected-field",
                                        name: "secretary_name",
                                        placeholder: "secretary name here",
                                        type: "text",
                                        rules: [_ctx.requiredField]
                                      }, null, 8, ["modelValue", "rules"]),
                                      _createVNode(_component_ErrorMessage, {
                                        style: {"color":"#d00000"},
                                        name: "secretary_name"
                                      })
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_103, [
                                    _createElementVNode("div", _hoisted_104, [
                                      _hoisted_105,
                                      _createVNode(_component_Field, {
                                        modelValue: _ctx.form.secretary_email,
                                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.form.secretary_email) = $event)),
                                        class: "form-control selected-field",
                                        name: "secretary_email",
                                        placeholder: "ie. chairmam@association.com",
                                        type: "text",
                                        rules: [_ctx.requiredField,_ctx.validateEmail]
                                      }, null, 8, ["modelValue", "rules"]),
                                      _createVNode(_component_ErrorMessage, {
                                        style: {"color":"#d00000"},
                                        name: "secretary_email"
                                      })
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_106, [
                                  _hoisted_107,
                                  _createElementVNode("div", _hoisted_108, [
                                    _createElementVNode("div", _hoisted_109, [
                                      _hoisted_110,
                                      _createVNode(_component_Field, {
                                        modelValue: _ctx.form.treasurer_name,
                                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.form.treasurer_name) = $event)),
                                        class: "form-control selected-field",
                                        name: "treasurer_name",
                                        placeholder: "treasurer name here",
                                        type: "text",
                                        rules: [_ctx.requiredField]
                                      }, null, 8, ["modelValue", "rules"]),
                                      _createVNode(_component_ErrorMessage, {
                                        style: {"color":"#d00000"},
                                        name: "treasurer_name"
                                      })
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_111, [
                                    _createElementVNode("div", _hoisted_112, [
                                      _hoisted_113,
                                      _createVNode(_component_Field, {
                                        modelValue: _ctx.form.treasurer_email,
                                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.form.treasurer_email) = $event)),
                                        class: "form-control selected-field",
                                        name: "treasurer_email",
                                        placeholder: "ie. chairmam@association.com",
                                        type: "text",
                                        rules: [_ctx.requiredField,_ctx.validateEmail]
                                      }, null, 8, ["modelValue", "rules"]),
                                      _createVNode(_component_ErrorMessage, {
                                        style: {"color":"#d00000"},
                                        name: "treasurer_email"
                                      })
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_114, [
                          _createElementVNode("div", _hoisted_115, [
                            _createElementVNode("div", _hoisted_116, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.openModal('cancel_request'))),
                                class: "btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Cancel ")
                            ]),
                            _createElementVNode("div", _hoisted_117, [
                              _createElementVNode("button", {
                                onClick: _cache[32] || (_cache[32] = ($event: any) => {_ctx.next_step=2;}),
                                type: "submit",
                                class: "subBtn btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save ")
                            ]),
                            _createElementVNode("div", _hoisted_118, [
                              _createElementVNode("button", {
                                onClick: _cache[33] || (_cache[33] = ($event: any) => {_ctx.next_step=3;}),
                                type: "submit",
                                class: "subBtn btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save & Next ")
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["onSubmit"]))
                : _createCommentVNode("", true),
              (this.current_step==3)
                ? (_openBlock(), _createBlock(_component_Banks, {
                    key: 2,
                    countries: _ctx.countries,
                    current_step: _ctx.current_step,
                    load_on: _ctx.load_on
                  }, null, 8, ["countries", "current_step", "load_on"]))
                : _createCommentVNode("", true),
              (this.current_step==3)
                ? (_openBlock(), _createBlock(_component_Form, {
                    key: 3,
                    method: "POST",
                    action: "/",
                    class: "my-1 card p-2",
                    onSubmit: _ctx.submitForm_3
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_119, [
                        _hoisted_120,
                        _createElementVNode("div", _hoisted_121, [
                          _createElementVNode("div", _hoisted_122, [
                            _createElementVNode("div", _hoisted_123, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.openModal('cancel_request'))),
                                class: "btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Cancel ")
                            ]),
                            _createElementVNode("div", _hoisted_124, [
                              _createElementVNode("button", {
                                onClick: _cache[35] || (_cache[35] = ($event: any) => {_ctx.next_step=4;}),
                                type: "submit",
                                class: "subBtn btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save & Next ")
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["onSubmit"]))
                : _createCommentVNode("", true),
              (this.current_step==4)
                ? (_openBlock(), _createBlock(_component_Form, {
                    key: 4,
                    method: "POST",
                    action: "/",
                    class: "my-1 card p-2",
                    onSubmit: _ctx.submitForm_4
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_125, [
                        _createElementVNode("div", _hoisted_126, [
                          _createElementVNode("div", _hoisted_127, [
                            _createElementVNode("div", _hoisted_128, [
                              _createElementVNode("div", _hoisted_129, [
                                _createElementVNode("div", _hoisted_130, [
                                  _createElementVNode("div", _hoisted_131, [
                                    _hoisted_132,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.esign_name,
                                      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.form.esign_name) = $event)),
                                      placeholder: "i.e. Jonaten ",
                                      class: "form-control selected-field",
                                      name: "esign_name",
                                      type: "text",
                                      rules: _ctx.requiredField
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "esign_name"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_133, [
                                  _createElementVNode("div", _hoisted_134, [
                                    _hoisted_135,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.esign_email_id,
                                      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.form.esign_email_id) = $event)),
                                      placeholder: "i.e. email@address.com  ",
                                      class: "form-control selected-field",
                                      name: "esign_email_id",
                                      type: "text",
                                      rules: [_ctx.requiredField,_ctx.validateEmail]
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "esign_email_id"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_136, [
                                  _createElementVNode("div", _hoisted_137, [
                                    _hoisted_138,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.esign_phone_no,
                                      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.form.esign_phone_no) = $event)),
                                      placeholder: "i.e. 3539 000556  ",
                                      class: "form-control selected-field",
                                      name: "esign_phone_no",
                                      type: "text",
                                      rules: [_ctx.requiredField,_ctx.mobileField]
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "esign_phone_no"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_139, [
                                  _createElementVNode("div", _hoisted_140, [
                                    _hoisted_141,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.esign_dob,
                                      "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.form.esign_dob) = $event)),
                                      class: "form-control selected-field",
                                      name: "esign_dob",
                                      type: "date",
                                      rules: _ctx.requiredField,
                                      onclick: "this.type='date'",
                                      onfocus: "this.type='date';",
                                      onblur: "(typeof this.value!='undefined' && this.value!='' && this.value!=null) ? this.type='date' : this.type='text'",
                                      placeholder: "D.O.B"
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "esign_dob"
                                    })
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_142, [
                          _createElementVNode("div", _hoisted_143, [
                            _createElementVNode("div", _hoisted_144, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.openModal('cancel_request'))),
                                class: "btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Cancel ")
                            ]),
                            _createElementVNode("div", _hoisted_145, [
                              _createElementVNode("button", {
                                onClick: _cache[41] || (_cache[41] = ($event: any) => {_ctx.next_step=4;}),
                                type: "submit",
                                class: "subBtn btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save ")
                            ]),
                            _createElementVNode("div", _hoisted_146, [
                              _createElementVNode("button", {
                                onClick: _cache[42] || (_cache[42] = ($event: any) => {_ctx.next_step=5;}),
                                type: "submit",
                                class: "subBtn btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save & Next ")
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["onSubmit"]))
                : _createCommentVNode("", true),
              (this.current_step==5)
                ? (_openBlock(), _createBlock(_component_Form, {
                    key: 5,
                    method: "POST",
                    action: "/",
                    class: "my-1 card p-2",
                    onSubmit: _ctx.submitForm_5
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_147, [
                        _createElementVNode("div", _hoisted_148, [
                          _createElementVNode("div", _hoisted_149, [
                            _createElementVNode("div", _hoisted_150, [
                              _createElementVNode("div", _hoisted_151, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.final_docs, (upload_doc) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "col-md-12 col-12",
                                    key: upload_doc.input_name
                                  }, [
                                    _createElementVNode("div", _hoisted_152, [
                                      _createElementVNode("label", _hoisted_153, _toDisplayString(upload_doc.name), 1),
                                      _hoisted_154,
                                      (typeof _ctx.records[upload_doc.input_name+'_url']!='undefined' && _ctx.records[upload_doc.input_name+'_url']!='')
                                        ? (_openBlock(), _createBlock(_component_Field, {
                                            key: 0,
                                            onChange: _cache[43] || (_cache[43] = ($event: any) => (_ctx.uploadFile($event))),
                                            modelValue: _ctx.form.driver_license,
                                            "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.form.driver_license) = $event)),
                                            class: "form-control selected-field",
                                            name: "driver_license",
                                            type: "file"
                                          }, null, 8, ["modelValue"]))
                                        : _createCommentVNode("", true),
                                      (typeof _ctx.records[upload_doc.input_name+'_url']=='undefined' || _ctx.records[upload_doc.input_name+'_url']=='')
                                        ? (_openBlock(), _createBlock(_component_Field, {
                                            key: 1,
                                            onChange: _cache[45] || (_cache[45] = ($event: any) => (_ctx.uploadFile($event))),
                                            modelValue: _ctx.form[upload_doc.input_name],
                                            "onUpdate:modelValue": ($event: any) => ((_ctx.form[upload_doc.input_name]) = $event),
                                            class: "form-control selected-field",
                                            name: upload_doc.input_name,
                                            type: "file",
                                            rules: _ctx.requiredField
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "rules"]))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_ErrorMessage, {
                                        style: {"color":"#d00000"},
                                        name: upload_doc.input_name
                                      }, null, 8, ["name"]),
                                      (typeof _ctx.records[upload_doc.input_name+'_url']!='undefined' && _ctx.records[upload_doc.input_name+'_url']!='')
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 2,
                                            class: "p-cursor",
                                            onClick: ($event: any) => {_ctx.openDoc(_ctx.records[upload_doc.input_name+'_url']);}
                                          }, [
                                            _createElementVNode("span", { innerHTML: _ctx.svg_image }, null, 8, _hoisted_156),
                                            _createTextVNode(" " + _toDisplayString(upload_doc.name), 1)
                                          ], 8, _hoisted_155))
                                        : _createCommentVNode("", true),
                                      (_ctx.form[upload_doc.input_name+'_pdiv']==1)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_157, [
                                            _createElementVNode("div", {
                                              class: "progress-bar bg-dark",
                                              role: "progressbar",
                                              style: _normalizeStyle({'width':_ctx.form[upload_doc.input_name+'_pbar']+'%'}),
                                              "aria-valuenow": _ctx.form[upload_doc.input_name+'_pbar'],
                                              "aria-valuemin": "0",
                                              "aria-valuemax": "100"
                                            }, _toDisplayString(_ctx.form[upload_doc.input_name+'_pbar_p']), 13, _hoisted_158)
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_Field, {
                                        rules: _ctx.requiredField,
                                        modelValue: _ctx.form[upload_doc.input_name+'_path'],
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.form[upload_doc.input_name+'_path']) = $event),
                                        class: "form-control selected-field",
                                        name: upload_doc.input_name+'_path',
                                        type: "hidden"
                                      }, null, 8, ["rules", "modelValue", "onUpdate:modelValue", "name"]),
                                      _createVNode(_component_ErrorMessage, {
                                        style: {"color":"#d00000"},
                                        name: upload_doc.input_name+'_path'
                                      }, null, 8, ["name"])
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_159, [
                          _createElementVNode("div", _hoisted_160, [
                            _createElementVNode("div", _hoisted_161, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.openModal('cancel_request'))),
                                class: "btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Cancel ")
                            ]),
                            _createElementVNode("div", _hoisted_162, [
                              _createElementVNode("button", {
                                onClick: _cache[47] || (_cache[47] = ($event: any) => {_ctx.next_step=5;}),
                                type: "submit",
                                class: "subBtn btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save ")
                            ]),
                            _createElementVNode("div", _hoisted_163, [
                              _createElementVNode("button", {
                                onClick: _cache[48] || (_cache[48] = ($event: any) => {_ctx.next_step=200;}),
                                type: "submit",
                                class: "subBtn btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save & Finish ")
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["onSubmit"]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _hoisted_164,
    _createElementVNode("div", _hoisted_165, [
      _createElementVNode("div", _hoisted_166, [
        _createElementVNode("div", _hoisted_167, [
          _createElementVNode("div", _hoisted_168, [
            _createElementVNode("div", _hoisted_169, [
              _hoisted_170,
              _createElementVNode("div", _hoisted_171, [
                _createElementVNode("button", {
                  class: "ok_btn",
                  onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.cancel_request(2)))
                }, "Ok"),
                _createElementVNode("button", {
                  onClick: _cache[50] || (_cache[50] = ($event: any) => (_ctx.closeModal('cancel_request'))),
                  class: "cancel_btn ml-2"
                }, "Cancel")
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_toasti, { ref: "toasti" }, null, 512)
  ], 64))
}